import React from "react";
import PlacesAutoComplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";

export const LocationAutocomplete = ({ value, onChange, onSelect, placeholder = "Enter your location", error, touched }) => {
  const handleSelect = async (address) => {
    // update the input value
    if (onChange) onChange(address);
    try {
      const results = await geocodeByAddress(address);
      if (!results || results.length === 0) {
        if (onSelect) onSelect({ address });
        return;
      }
      const best = results[0];
      const latLng = await getLatLng(best); // { lat, lng }

      const placeDetails = {
        address: best.formatted_address || address,
        place_id: best.place_id,
        lat: latLng.lat,
        lng: latLng.lng,
        raw: best,
      };
      if (onSelect) onSelect(placeDetails);
    } catch (err) {
      console.error("LocationAutocomplete select error:", err);
      // still call onSelect minimally
      if (onSelect) onSelect({ address });
    }
  };

  return (
    <PlacesAutoComplete value={value} onChange={onChange} onSelect={handleSelect} debounce={300}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div className="relative">
          <input
            {...getInputProps({
              placeholder,
              className:
                "w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none  focus:ring-1 focus:ring-primary focus:border-primary",
            })}
          />
          <div className="absolute left-0 right-0 z-50 mt-1 bg-white  rounded-md max-h-60 overflow-auto">
            {loading && <div className="p-2 text-sm">Loading...</div>}

            {suggestions.map((suggestion) => {
              const className = suggestion.active ? "p-3 cursor-pointer bg-gray-100" : "p-3 cursor-pointer";
              // suggestion may have placeId or place_id
              const key = suggestion.placeId || suggestion.description;
              return (
                <div
                  {...getSuggestionItemProps(suggestion, { className })}
                  key={key}
                >
                  {suggestion.description}
                </div>
              );
            })}
          </div>
          {touched && error && (
            <p className="text-red-600 text-sm mt-1">{error}</p>
          )}
        </div>
      )}
    </PlacesAutoComplete>
  );
};

export default LocationAutocomplete;
